import React, { useState, useEffect, useMemo } from "react"
import {
  Table,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Input,
  Modal,
  Form,
  Label,
  NavLink,
  NavItem,
  Nav,
  TabContent,
  TabPane,
  CardTitle,
} from "reactstrap"
import { Link } from "react-router-dom"
import classnames from "classnames"
import { useTable, usePagination, useGlobalFilter } from "react-table"
import NewPagination from "components/Common/Newpagination";
import configure from "configure"
import {
  fetchNodeData,
  FetchNodePostData,
  FetchNodePutData,
  FetchNodeDeleteData,
} from "utils/common-fetchData"
import secureLocalStorage from "react-secure-storage"
import Loader from "pages/Separate/Loader"
import Swal from "sweetalert2"

// Reusable TableContainer (replaces TableContainer, TableContainer2, TableContainer3)
const TableContainer = ({ columns, data, onAddClick, title, location }) => {
  const [fixButtons, setFixButtons] = useState(false)
  const [fixedContent, setFixedContent] = useState(false)

  // Scroll handlers for fixed header/buttons
  useEffect(() => {
    const handleScroll = () => {
      setFixButtons(window.scrollY > 160)
      setFixedContent(window.scrollY > 165)
    }
    window.addEventListener("scroll", handleScroll)
    return () => window.removeEventListener("scroll", handleScroll)
  }, [])

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    state,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
    setGlobalFilter,
  } = useTable({ columns, data }, useGlobalFilter, usePagination)

  const { pageIndex, pageSize, globalFilter } = state

  return (
    <div>
      {/* Fixed Buttons */}
      <div
        className={`flex-column fixed-buttons ${
          fixButtons ? "d-flex" : "d-none"
        }`}
      >
        <button
          onClick={onAddClick}
          className="btn btn-purple border-radius fix-btn"
        >
          <i className="fas fa-plus me-2"></i>
          <span>Source</span>
        </button>
        <Link
          to={`${configure.appUrl}staff`}
          className="btn btn-red border-radius fix-btn"
        >
          <i className="dripicons-cross me-2 icon-center"></i>
          <span>Cancel</span>
        </Link>
      </div>

      <Row className="mb-2">
        <CardTitle className="h4 mb-25">{title}</CardTitle>
        <Col lg={2}>
          <select
            className="border-radius form-select"
            style={{ width: "100px" }}
            value={pageSize}
            onChange={e => setPageSize(Number(e.target.value))}
          >
            {[10, 20, 30, 40, 50].map(size => (
              <option key={size} value={size}>
                Show {size}
              </option>
            ))}
          </select>
        </Col>
        <Col className="d-flex justify-content-end">
          <div className="me-4">
            <div className="search-box me-xxl-2 my-xxl-0 d-inline-block">
              <div className="position-relative">
                <label htmlFor="search-bar-0" className="search-label">
                  <input
                    onChange={e => setGlobalFilter(e.target.value)}
                    type="text"
                    className="border-radius form-control rounded h-100"
                    placeholder="Search..."
                    value={globalFilter || ""}
                  />
                </label>
                <i className="bx bx-search-alt search-icon"></i>
              </div>
            </div>
          </div>
          <div>
            <button
              onClick={onAddClick}
              className="border-radius btn btn-purple"
            >
              <i className="fas fa-plus me-2 icon-size"></i>Add Source
            </button>
            <Link
              to={`${configure.appUrl}staff`}
              className="border-radius btn text-white ms-md-2 btn-red"
            >
              <i className="dripicons-cross me-2 icon-center"></i>Cancel
            </Link>
          </div>
        </Col>
      </Row>

      <Table className="table table-bordered mt-4" {...getTableProps()}>
        <thead className={`${fixedContent ? "fixed-setting-header" : ""}`}>
          {headerGroups.map((headerGroup, i) => (
            <tr key={i} {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column, index) => (
                <th
                  key={index}
                  className={`col-md-${
                    index === 0 ? "1" : index === 1 ? "9" : "2"
                  }`}
                  {...column.getHeaderProps()}
                >
                  {column.render("Header")}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map((row, i) => {
            prepareRow(row)
            return (
              <tr className="row-hover" {...row.getRowProps()} key={i}>
                {row.cells.map((cell, index) => (
                  <td
                    key={index}
                    className={`col-md-${
                      index === 0 ? "1" : index === 1 ? "9" : "2"
                    }`}
                    {...cell.getCellProps()}
                  >
                    {cell.render("Cell")}
                  </td>
                ))}
              </tr>
            )
          })}
        </tbody>
      </Table>

      <Row className="justify-content-md-end justify-content-center align-items-center">
        <NewPagination
          gotoPage={gotoPage}
          canPreviousPage={canPreviousPage}
          canNextPage={canNextPage}
          pageIndex={pageIndex}
          pageOptions={pageOptions}
          pageSize={pageSize}
          page={page}
          data={data}
        />
      </Row>
    </div>
  )
}

const Source = () => {
  const token = secureLocalStorage.getItem("token")

  // States
  const [sourceList, setSourceList] = useState([])
  const [loading, setLoading] = useState(false)
  const [modalOpen, setModalOpen] = useState(false)
  const [editId, setEditId] = useState(null)
  const [formData, setFormData] = useState({
    number: "",
    name: "",
    location: 1, // default India
  })
  const [verticalActiveTab, setverticalActiveTab] = useState("1")

  // Load data from API
  const loadSources = async () => {
    const res = await fetchNodeData(setLoading, "leadSource", token)
    if (res?.data) {
      console.log("res: ", res?.data)
      setSourceList(res.data)
    }
  }

  useEffect(() => {
    loadSources()
  }, [])

  // Filter data by location
  const indiaData = sourceList.filter(x => x.location == 1)
  const ukData = sourceList.filter(x => x.location == 2)
  const usaData = sourceList.filter(x => x.location == 3)

  // Open modal for Add (set location based on active tab)
  const openAddModal = location => {
    setEditId(null)
    setFormData({ number: "", name: "", location })
    setModalOpen(true)
  }

  // Open modal for Edit
  const openEditModal = item => {
    setEditId(item.id)
    setFormData({
      number: item.number || "",
      name: item.leadname || "",
      location: item.location,
    })
    setModalOpen(true)
  }

  // Handle form submit (Add or Edit)
  const handleSubmit = async (e) => {
  e.preventDefault();

  const payload = {
    number: formData.number,
    leadname: formData.name,
    location: formData.location,
  };

  try {
    let res;

    if (editId) {
      res = await FetchNodePutData(setLoading, "leadSource", editId, payload);
    } else {
      res = await FetchNodePostData(setLoading, "leadSource", token, payload);
    }

    if (res?.status || res?.data?.status) {
      Swal.fire(
        "Success",
        editId
          ? "Source updated successfully"
          : "Source created successfully",
        "success"
      );

      setModalOpen(false);
      await loadSources();
    } else {
      Swal.fire(
        "Error",
        res?.data?.message || "Operation failed",
        "error"
      );
    }
  } catch (error) {
    console.error(error);
    Swal.fire("Error", "Something went wrong!", "error");
  }
};


  // Delete handler
  const handleDelete = async id => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async result => {
      if (result.isConfirmed) {
        try {
          const response = await fetchNodeData(
            setLoading,
            `leadSource/${id}`,
            secureLocalStorage.getItem("auth_token")
          )

          console.log("Delete response:", response?.status)

          if (response?.status) {
            await loadSources()
            Swal.fire("Deleted!", "Source has been deleted.", "success")
          } else {
            Swal.fire(
              "Error",
              response?.data?.message || "Failed to delete Source",
              "error"
            )
          }
        } catch (error) {
          console.error(error)
          Swal.fire("Error", "Something went wrong!", "error")
        }
      }
    })
  }

  // Columns (shared for all tabs)
  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "number",
      },
      {
        Header: "Source Name",
        accessor: "leadname",
      },
      {
        Header: "Action",
        Cell: cellProps => {
          const item = cellProps.row.original
          return (
            <div>
              <a
                onClick={() => openEditModal(item)}
                className="btn btn-sm me-1 btn-outline-secondary"
              >
                <i className="fas fa-pencil-alt"></i>
              </a>
              <a
                onClick={() => handleDelete(item.id)}
                className="btn btn-sm btn-danger"
              >
                <i className="fas fa-trash-alt"></i>
              </a>
            </div>
          )
        },
      },
    ],
    []
  )

  const toggleVertical = tab => {
    if (verticalActiveTab !== tab) setverticalActiveTab(tab)
  }

  return (
    <>
      {loading && <Loader />}
      <Row>
        <Col lg={12} className="p-0">
          <CardBody className="pl-0 pt-0">
            <Row>
              <Col md="2" className="bd-source-tab">
                <Nav pills className="flex-column">
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        "mb-2": true,
                        active: verticalActiveTab === "1",
                      })}
                      onClick={() => toggleVertical("1")}
                    >
                      India
                    </NavLink>
                  </NavItem>
                  {/* <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        "mb-2": true,
                        active: verticalActiveTab === "2",
                      })}
                      onClick={() => toggleVertical("2")}
                    >
                      United Kingdom
                    </NavLink>
                  </NavItem> */}
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        "mb-2": true,
                        active: verticalActiveTab === "3",
                      })}
                      onClick={() => toggleVertical("3")}
                    >
                      United States
                    </NavLink>
                  </NavItem>
                </Nav>
              </Col>
              <Col md="10" style={{ paddingLeft: "30px" }}>
                <TabContent
                  activeTab={verticalActiveTab}
                  className="text-muted mt-4 mt-md-0"
                >
                  <TabPane tabId="1" className="pt-30">
                    <div className="responsive-table">
                      <TableContainer
                        columns={columns}
                        data={indiaData}
                        onAddClick={() => openAddModal(1)}
                        title="Indian Source"
                      />
                    </div>
                  </TabPane>
                  {/* <TabPane tabId="2" className="pt-30">
                    <div className="responsive-table">
                      <TableContainer
                        columns={columns}
                        data={ukData}
                        onAddClick={() => openAddModal(2)}
                        title="United Kingdom Source"
                      />
                    </div>
                  </TabPane> */}
                  <TabPane tabId="3" className="pt-30">
                    <div className="responsive-table">
                      <TableContainer
                        columns={columns}
                        data={usaData}
                        onAddClick={() => openAddModal(3)}
                        title="United States Source"
                      />
                    </div>
                  </TabPane>
                </TabContent>
              </Col>
            </Row>
          </CardBody>
        </Col>

        {/* Unified Add/Edit Modal */}
        <Modal isOpen={modalOpen} size="sm" centered className="bd-custom-md-2">
          <div className="modal-header">
            <h5 className="modal-title mt-0">
              {editId ? "Edit Source" : "Add Source"}
            </h5>
            <button
              type="button"
              onClick={() => setModalOpen(false)}
              className="btn-modal-close"
            >
              <span className="btn-modal-span">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <Form className="row" onSubmit={handleSubmit}>
              <div className="mb-3 col-md-3">
                <Label>Number</Label>
                <Input
                  type="text"
                  value={formData.number}
                  onChange={e =>
                    setFormData({ ...formData, number: e.target.value })
                  }
                />
              </div>
              <div className="mb-3 col-md-9">
                <Label>Name</Label>
                <Input
                  type="text"
                  value={formData.name}
                  onChange={e =>
                    setFormData({ ...formData, name: e.target.value })
                  }
                />
              </div>
              <div className="mt-20">
                <button className="border-radius btn btn-purple">
                  {editId ? "Update" : "Submit"}
                </button>
              </div>
            </Form>
          </div>
        </Modal>
      </Row>
    </>
  )
}

export default Source
